/* Finish One Room Today - Interactions
   - Before/After image comparison sliders (drag + keyboard)
*/

(function () {
  'use strict';

  // ============ SLIDERS ============
  var sliders = document.querySelectorAll('[data-slider]');

  sliders.forEach(function (slider) {
    var clip = slider.querySelector('.slider__clip');
    var beforeImg = slider.querySelector('.slider__img--before');
    var handle = slider.querySelector('.slider__handle');
    if (!clip || !beforeImg || !handle) return;

    var dragging = false;

    function setPosition(percent) {
      percent = Math.max(0, Math.min(100, percent));
      clip.style.width = percent + '%';
      handle.style.left = percent + '%';
      handle.setAttribute('aria-valuenow', Math.round(percent));

      var rect = slider.getBoundingClientRect();
      beforeImg.style.width = rect.width + 'px';
    }

    function updateBeforeImageWidth() {
      var rect = slider.getBoundingClientRect();
      beforeImg.style.width = rect.width + 'px';
    }

    function getPercentFromEvent(clientX) {
      var rect = slider.getBoundingClientRect();
      var x = clientX - rect.left;
      return (x / rect.width) * 100;
    }

    function onDown(e) {
      dragging = true;
      slider.style.cursor = 'ew-resize';
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      setPosition(getPercentFromEvent(clientX));
      e.preventDefault();
    }

    function onMove(e) {
      if (!dragging) return;
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      setPosition(getPercentFromEvent(clientX));
    }

    function onUp() {
      dragging = false;
      slider.style.cursor = '';
    }

    slider.addEventListener('mousedown', onDown);
    slider.addEventListener('touchstart', onDown, { passive: false });
    window.addEventListener('mousemove', onMove);
    window.addEventListener('touchmove', onMove, { passive: false });
    window.addEventListener('mouseup', onUp);
    window.addEventListener('touchend', onUp);

    handle.addEventListener('keydown', function (e) {
      var current = parseFloat(handle.getAttribute('aria-valuenow')) || 50;
      var next = current;
      if (e.key === 'ArrowLeft') next = current - 5;
      else if (e.key === 'ArrowRight') next = current + 5;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = 100;
      else return;
      e.preventDefault();
      setPosition(next);
    });

    handle.addEventListener('click', function (e) { e.stopPropagation(); });
    window.addEventListener('resize', updateBeforeImageWidth);

    setPosition(50);
    updateBeforeImageWidth();

    // Load-in hint animation
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var hinted = false;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !hinted) {
            hinted = true;
            setTimeout(function () {
              animateTo(35, 500, function () {
                animateTo(65, 500, function () {
                  animateTo(50, 400);
                });
              });
            }, 300);
          }
        });
      }, { threshold: 0.3 });
      observer.observe(slider);
    }

    function animateTo(target, duration, done) {
      var start = parseFloat(handle.getAttribute('aria-valuenow')) || 50;
      var change = target - start;
      var startTime = performance.now();

      function step(now) {
        var elapsed = now - startTime;
        var t = Math.min(1, elapsed / duration);
        var eased = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
        setPosition(start + change * eased);
        if (t < 1) requestAnimationFrame(step);
        else if (done) done();
      }
      requestAnimationFrame(step);
    }
  });

  // ============ ZAPIER FORM ============
  var forms = document.querySelectorAll('[data-zapier-form]');

  forms.forEach(function (form) {
    var responseFrame = document.querySelector('[data-zapier-response][name="' + form.target + '"]');

    if (responseFrame) {
      responseFrame.addEventListener('load', function () {
        if (form.getAttribute('data-submitting') !== 'true') return;

        var confirmation = document.createElement('div');
        confirmation.className = 'finish-form__confirmation';
        confirmation.setAttribute('role', 'status');
        confirmation.setAttribute('aria-live', 'polite');
        confirmation.innerHTML = '<h3>Thank you!</h3><p>A Gallery Furniture expert will reach out shortly to confirm your appointment.</p>';
        form.replaceWith(confirmation);
      });
    }

    form.addEventListener('submit', function (event) {
      if (!form.checkValidity()) {
        event.preventDefault();
        form.reportValidity();
        return;
      }

      var button = form.querySelector('[data-submit-button]');
      var status = form.querySelector('[data-form-status]');
      var originalLabel = button ? button.textContent : '';

      if (button) {
        button.disabled = true;
        button.textContent = 'Sending...';
      }
      if (status) {
        status.className = 'finish-form__status is-note';
        status.textContent = 'Sending your request...';
      }

      form.setAttribute('data-submitting', 'true');

      window.setTimeout(function () {
        if (button && button.isConnected) {
          button.disabled = false;
          button.textContent = originalLabel;
        }
      }, 15000);
    });
  });
})();
